// constants/index.js
// Firebase 관련 상수
export const FIRESTORE_CONSTANTS = {
    ROOT_COLLECTION: process.env.REACT_APP_FIRESTORE_ROOT_COLLECTION || 'kor',
    DOCUMENT_FIELDS: {
      TITLE: 'title',
      ORDER: 'order',
      CONTENT: 'content',
      SUBTITLE: 'subtitle',
      SUBCOLLECTIONS: 'subcollections'
    },
    DEFAULT_ORDER: 9999
  };
  
  // 폼 관련 상수
  export const FORM_CONSTANTS = {
    FORMSPREE_ID: process.env.REACT_APP_FORMSPREE_ID || 'movjgdeo'
  };
  
  // 레이아웃 관련 상수
  export const LAYOUT_CONSTANTS = {
    SITE_TITLE: process.env.REACT_APP_SITE_TITLE || '젠더툴킷',
    BREADCRUMB_SEPARATOR: '/'
  };
  
  // 라우트 관련 상수
  export const ROUTE_CONSTANTS = {
    HOME: '/',
    CONTACT: '/contact',
    DYNAMIC_CATEGORY: '/:category',
    DYNAMIC_SUBCATEGORY: '/:category/:subcategory'
  };


  
